import React from 'react';
import PropTypes from 'prop-types';
import Page from '../../lib/page';

const { error } = Page.getLocaleContent('Error');

const Error = props => (
  (
    <div className="error-block-container">
      <div className="vx_icon vx_icon-large vx_icon-critical-large" />
      <div className="vx_text-1 error-msg">{props.message}</div>
      <div className="vx_text-3  error-inst">{props.tryAgain}</div>
    </div>
  )
);


Error.propTypes = {
  tryAgain: PropTypes.string,
  message: PropTypes.string,
};

Error.defaultProps = {
  tryAgain: error.tryAgain,
  message: error.message,
};

export default Error;
